export default __webpack_public_path__ + "star.e9a24063f926f6bc.svg";